import validate from "/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45redirect_45trailing_45slash_45global from "/build/middleware/00.redirect-trailing-slash.global.ts";
import _01_45general_45middleware_45global from "/build/middleware/01.general-middleware.global.ts";
export const globalMiddleware = [
  validate,
  _00_45redirect_45trailing_45slash_45global,
  _01_45general_45middleware_45global
]
export const namedMiddleware = {}